import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTopbarHiddenTopWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"topbar-hidden-top-wide"} maskId="square-filled-radius-0-stroke-1-IconTopbarHiddenTopWide"><path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM6 9H18V8H6V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTopbarHiddenTopWide;
